import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'generateRange', standalone: true })
export class GenerateRangePipe implements PipeTransform {
  transform(input: number) {
    return Array.from({ length: input }, (_, i) => i);
  }
}
